<template>
  <v-card class="align-stretch" height="100%" :loading="currentLeadLoading">
    <v-card-title>
      Customer Details
      <v-spacer></v-spacer>
      <v-btn class="mt-0" color="secondary" x-small @click="dialogOpen=true;"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>
    <v-card-text v-if="!currentLeadLoading">
      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Business Name</p>
          <p><b>{{currentLead.business_name | notEmpty}}</b></p>
          <p class="mb-1 text-caption">Customer Phone</p>
          <p><b>{{(currentLead.contact!==undefined)?currentLead.contact.phone_number:'-' | notEmpty}}</b></p>
          <p class="mb-1 text-caption">Industry</p>
          <p><b>{{currentLead.industry | notEmpty}}</b></p>
        </v-col>
        <v-col>
          <p class="mb-1 text-caption">Customer Name</p>
          <p><b>{{(currentLead.contact!==undefined)?currentLead.contact.name:'-' | notEmpty}}</b></p>
          <p class="mb-1 text-caption">Email Address</p>
          <p><b>{{(currentLead.contact!==undefined)?currentLead.contact.email_address:'-' | notEmpty}}</b></p>
        </v-col>
        <v-col>
          <p class="mb-1 text-caption">Mobile Phone</p>
          <p><b>{{(currentLead.contact!==undefined)?currentLead.contact.mobile_number:'-' | notEmpty}}</b></p>
          <p class="mb-1 text-caption">Post code</p>
          <p><b>{{currentLead.address_post_code | notEmpty}}</b></p>
          <!-- <p class="mb-1 text-caption">Interested In</p>
          <p><b>{{currentLead.interested_in | notEmpty}}</b></p> -->
        </v-col>
      </v-row>
    </v-card-text>
    <CustomerDetailsDialog :dialogOpen="dialogOpen" @close-dialog="dialogOpen=false;" />
  </v-card>
</template>

<script>
  import CustomerDetailsDialog from './Dialogs/CustomerDetailsDialog';
  import { mapState } from "vuex";
  export default {
    components: { CustomerDetailsDialog },
    computed: { ...mapState('leads', ['currentLead','currentLeadLoading']) },
    data() {
      return {
        dialogOpen: false
      }
    },
    filters: {
      notEmpty: function(val) {
        return (val === null || val === "" || val === undefined)?'-':val;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
